import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { CourtScheduleConfigurationDto } from "../../../models/court/dto/configuration.dto";

export const GET_COURT_CONFIGURATIONS_QUERY_KEY = (courtId: number) => ['court-configurations', courtId];

export const useGetCourtConfigurations = (courtId: number) => {
    const apiClient = useApiClient();

    return useQuery({
        // `CourtDetailsPage` computes `Number.parseInt(paramFromWindowLocation
        // ('court'))`, i.e. NaN when the param is missing or garbled, and gates
        // its OWN calendar query on `Number.isInteger` for exactly that reason
        // (Sentry MYSPORTSET-API-E9 / -EA). The configuration tab it renders
        // underneath was left ungated, so `#/admin/courtDetails?tab=configuration`
        // with no `?court=` requested `courts/NaN/configurations` — a 400 from
        // the route's `ParseIntPipe`. Same guard, same file, now consistent.
        enabled: Number.isInteger(courtId),
        queryKey: GET_COURT_CONFIGURATIONS_QUERY_KEY(courtId),
        queryFn: () => apiClient.fetchApi<CourtScheduleConfigurationDto[], {}>({
            method: 'GET',
            endpoint: `courts/${courtId}/configurations`
        }),
        staleTime: 30_000
    });
};